

















import { Component, Vue, Prop } from 'vue-property-decorator'
import { UnitFileData } from '@/api/heritageUnit/unitBase'
import { thumbnailServer } from '@/api/common/upload'
import { AttachInfo } from '@/api/common/attach'

@Component
export default class UnitFileGallery extends Vue {
  public name = 'UnitFileGallery'

  @Prop({ default: [] })
  public fileList!: UnitFileData[]

  public getFileUrl(f: AttachInfo) {
    return thumbnailServer(f.Id, f.TempGuid, f.Name)
  }
  public showDetail(index: number) {
    // var f = this.fileList[index]
    // window.eventBus.$emit('openUnitFileDetail', f)
    window.eventBus.$emit('showImageViewer', {
      images: this.fileList,
      index: index
    })
  }
}
